import { captureException } from '@sentry/nextjs';
import { requestServer } from '@repo/ui/src/utils/graphql-request';
import { ShopFragment } from '@graphql/fragments';
import { ProductModelProps } from '@typings/product';

export const searchProductListItems = /* GraphQL */ `
  query SearchProductListItems(
    $filter: SearchableProductFilterInput
    $pageSize: Int
    $currency: String
  ) {
    searchProductListItems(filter: $filter, pageSize: $pageSize) {
      hits {
        _meta {
          name
          schema
          deliveryKey
          deliveryId
          url
        }
        id
        title
        description
        color
        productData {
          categories {
            categories
          }
          sku
          newArrivalStart
          newArrivalEnd
        }
        shopData(currency: $currency) {
          ...Shop
        }
        images {
          name
          endpoint
          defaultHost
          url
        }
        ratingSummary {
          average
        }
      }
    }
  }
  ${ShopFragment}
`;

export interface QueryResponse {
  searchProductListItems: {
    hits: ProductModelProps[];
  };
}

interface PropsWithIDs {
  ids?: Array<string>;
  skus?: never;
  locale: string;
  currency: string;
}
interface PropsWithSKUs {
  ids?: never;
  skus?: Array<string>;
  locale: string;
  currency: string;
}

const getProductListData = async ({
  ids,
  skus,
  locale,
  currency,
}: PropsWithIDs | PropsWithSKUs) => {
  if (!ids?.length && !skus?.length) return [];
  try {
    const data = await requestServer<QueryResponse>({
      document: searchProductListItems,
      variables: {
        filter: ids ? { ids } : { sku: skus },
        pageSize: ids?.length ?? skus?.length,
        currency: currency,
      },
      requestHeaders: {
        'Accept-Language': locale || 'en-US',
      },
    });

    return data.searchProductListItems.hits;
  } catch (error) {
    captureException(error);
    return [];
  }
};

export default getProductListData;
